import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "video-canvas-wrap flex-column-box" }
const _hoisted_2 = {
  id: "custom-context-menu",
  class: "radius-middle"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "background-video-player-outbox" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "control-buttons"
}

import { ref, onMounted, reactive, watch, computed } from 'vue';
import { fabric } from 'fabric';
import { useVideoStore, useDesignerStore } from '@/pinia';
import { ElMessage } from 'element-plus';
import { emitter } from '@/utils/events';


export default /*@__PURE__*/_defineComponent({
  __name: 'video',
  props: {
  digitalMan: {
    type: Object,
    default: () => ({}),
  },
  audioText: {
    type: Array,
    default: () => [],
  },
  audioTextStyle: {
    type: Object,
    default: () => {
      return {
        fontSize: 16,
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 1,
        backgroundColor: 'rgba(0,0,0,0)',
        shadowColor: 'rgba(0,0,0,0)',
        shadowX: 0,
        shadowY: 0,
        shadowBlur: 0,
        shadowDistance: 0,
        left: 420,
        top: 400,
        rotate: 30,
        scale: 100,
        transparent: 100,
      };
    },
  },

  background: {
    default: () => {
      return {
        url: '',
      };
    },
  },
  anchorParam: {
    type: Object,
    default: () => ({ scale: 1 }),
  },
  images: {
    type: Array,
    default: () => [],
  },

  logoArr: {
    type: Array,
    default: () => [],
  },

  playDemo: {
    type: Boolean,
    default: false,
  },

  clearFlag: {
    type: Boolean,
    default: false,
  },
  screen: {
    type: String,
    default: '',
  },
  logoParams: {
    type: Array,
    default: () => [],
  },
},
  emits: ['durationChange', 'loaded', 'sourceChange', 'canvasSizeChange'],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const ctx = ref();
let canvas = ref();
let canvasWidth = ref(0);
let canvasHeight = ref(0);
const props = __props;
let copyImgFn = () => {
  console.log('aalogoParams', props.logoParams);


}

// watch(props.background, (newVal, oldVal) => {
//   changeBackground();
// })

// watch(props.images, (newVal, oldVal) => {
//   addImage();
// })
const contextmenus = ref([
  { label: '复制', value: 1, disabled: false },
  { label: '粘贴', value: 2, disabled: true },
  // { label: '上移一层', value: 3, disabled: false },
  // { label: '下移一层', value: 4, disabled: false },
  { label: '置顶', value: 5, disabled: false },
  { label: '置底', value: 6, disabled: false },
  { label: '删除', value: 7, disabled: false },
]);
const contextShow = ref(false);
const contextELe = ref();

const showContextMenu = (x, y) => {
  // 创建并显示右键菜单
  contextShow.value = true;
  setTimeout(() => {
    var menu = document.getElementById('custom-context-menu');
    menu.style.left = x + 'px';
    menu.style.top = y + 'px';
  }, 0);
};
const backgroundVideoPlayer = ref(null);

const videoStore = useVideoStore();
const designerStore = useDesignerStore();
const videoWidth = ref(0)
const videoHeight = ref(0)
const preloadUrl = ref('');
const fullWidth = computed(() => {
  return canvasWidth.value / videoWidth.value > canvasHeight.value / videoHeight.value
})

const contextHanlders = {
  1: () => copyEle(),
  2: () => pasteEle(),
  3: () => bringForward(),
  4: () => sendBackwards(),
  5: () => bringToFront(),
  6: () => sendToBack(),
  7: () => deleteEle(),
};

const handleContext = (optType, disabled) => {
  if (disabled) return;
  const contextHanlder = contextHanlders[optType];
  if (contextHanlder) contextHanlder();
  contextShow.value = false;
};

const logos = [];
const initCanvas = (upDate) => {
  if (canvas.value) canvas.value.dispose();
  canvas.value = new fabric.Canvas('video-canvas', {
    width: canvasWidth.value, // 画布宽度
    height: canvasHeight.value, // 画布高度
    stopContextMenu: true,
    controlsAboveOverlay: true,
    selection: false,
    preserveObjectStacking: true, // 保持对象堆叠顺序，
    originX: 'center',
    originY: 'center',
    backgroundColor: '#fff',
    crossOrigin: 'anonymous'
  });
  canvas.value.hoverCursor = 'pointer';

  // 右键菜单
  canvas.value.upperCanvasEl.oncontextmenu = (event) => {
    var selectedObjects = canvas.value.getActiveObjects();
    const { offsetX, offsetY, clientX, clientY } = event;
    if (selectedObjects.length == 0) return;
    const [currentEl] = selectedObjects.filter((el) => {
      const { lineCoords } = el;
      if (offsetX > lineCoords.tl.x && offsetX < lineCoords.br.x && offsetY > lineCoords.tl.y && offsetY < lineCoords.br.y)
        return el;
    });
    contextELe.value = currentEl;
    if (!contextELe.value) return;
    if (contextELe.value.type && contextELe.value.type == 'digitalman') {
      contextmenus.value[0].disabled = true;
    } else {
      contextmenus.value[0].disabled = false;
    }

    showContextMenu(offsetX, offsetY);
  };

  canvas.value.upperCanvasEl.onclick = () => {
    contextShow.value = false;
  };

  canvas.value.on('object:modified', (ev) => {

    const { angle, top, left, scaleX, scaleY, width, height, cacheKey, id } = ev.target;
    let transformInfo = { angle, top, left, scaleX, scaleY, width, height };
    const [logoItem] = logos.filter((l) => l.id === id);

    if (logoItem) {

      const [rationW, rationH] = props.digitalMan.resolution.split('x');
      transformInfo.oriScaleX = scaleX;
      transformInfo.scaleX = (((logoItem.width * scaleX) / canvasWidth.value) * rationW) / logoItem.width;
      transformInfo.scaleY = (((logoItem.height * scaleY) / canvasHeight.value) * rationH) / logoItem.height;
      const obj = {
        ...logoItem,
        ...transformInfo,
      };

      emits('sourceChange', 11, obj);
    }
    if (id == props.digitalMan.virtualManKey) {
      //  参数值以下:
      //  定义宽高比: ratio
      //  画布宽尺寸：canvasWidth.value
      //  画布高尺寸：canvasHeight.value * ratio
      //  初始缩放比例：scaleRatio.value是画布高 / 画布上数字人图片高度计算出来的
      //  位于画布上数字人图片尺寸宽高：width, heigh 
      //  位于画布上数字人图片移动距离xy：x y
      //  数智人初始缩放系数，值精确到小数点后3位: originZoomStr
      //  问题:我想获取位于画布上数字人图片移动的距离
      //  原来逻辑
      //  20240516
      transformInfo.scaleX = (scaleX / scaleRatio.value) * (props.anchorParam?.scale || 1)
      let y = transformInfo.top
      let x = transformInfo.left


      // 人左+人中心
      let anchorWidth = (width * scaleX / 2)
      let perLeft = x + anchorWidth
      // 画面画布宽度的一半
      let containerWidthHalf = canvasWidth.value / 2
      transformInfo.left = (perLeft - containerWidthHalf) / canvasWidth.value
      // 人下距离
      let anchorHeight = (height * scaleY)
      transformInfo.top = (anchorHeight + y - canvasHeight.value) / 2 / anchorHeight


      emits('sourceChange', 14, { ...transformInfo, x: (x / canvasWidth.value) * 100, y: (y / canvasHeight.value) * 100 });
    }
  });

  if (upDate) {
    changeBackground();
    addDigitalman();
    // addAudioText();
    // addImage();
    addLogo(upDate);
  }
};

// 改变视频背景
const changeBackground = () => {
  if (videoStore.clipVideoUrl || designerStore.bgVideoUrl) {
    canvas.value?.setBackgroundColor(null, canvas.value.renderAll.bind(canvas.value));
    canvas.value?.setBackgroundImage(null, canvas.value.renderAll.bind(canvas.value));
    return;
  }
  if (props.background.material_type == 'bgcolor') {
    canvas.value.setBackgroundColor(props.background.name, canvas.value.renderAll.bind(canvas.value));
  } else {
    fabric.Image.fromURL(props.background.url, function (img) {
      img.set({
        originX: 'left',
        originY: 'top',
        scaleX: canvasWidth.value / img.width,
        scaleY: canvasHeight.value / img.height,
        crossOrigin: 'anonymous',
      });
      canvas.value.setBackgroundImage(img, canvas.value.renderAll.bind(canvas.value));
    }, { crossOrigin: 'anonymous' });
  }
};
const scaleRatio = ref();
const canvasRatio = ref();
const imageHeight = ref();
const imageWidth = ref();

const moveDigitalMan = (position) => {
  const digitalMan = canvas.value.getObjects().find((obj) => obj.type === "digitalman");



  if (!digitalMan || !digitalMan.set) return;

  const digitalManWidth = digitalMan.width * digitalMan.scaleX;

  switch (position) {
    case 'left':
      digitalMan.set({ left: 0 });
      break;
    case 'center':
      digitalMan.set({ left: canvasWidth.value / 2 - digitalManWidth / 2 });
      break;
    case 'right':
      digitalMan.set({ left: canvasWidth.value - digitalManWidth });
      break;
  }

  const { angle, top, left, scaleX, scaleY, width, height, cacheKey, id } = digitalMan
  let transformInfo = { angle, top, left, scaleX, scaleY, width, height };
  transformInfo.scaleX = (scaleX / scaleRatio.value)
  let y = transformInfo.top
  let x = transformInfo.left
  // 人左+人中心
  let anchorWidth = (width * scaleX / 2)
  let perLeft = x + anchorWidth
  // 画面画布宽度的一半
  let containerWidthHalf = canvasWidth.value / 2
  transformInfo.left = (perLeft - containerWidthHalf) / canvasWidth.value

  // 人下距离
  let anchorHeight = (height * scaleY)
  transformInfo.top = (anchorHeight + y - canvasHeight.value) / 2 / anchorHeight

  emits('sourceChange', 14, transformInfo);

  digitalMan.setCoords();
  canvas.value.renderAll();
};
const changeCanvasSize = (screenType = '') => {
  if (screenType === '横屏' || props.digitalMan.resolution == '1920x1080') {
    const ratio = 1080 / 1920;
    canvasWidth.value = document.querySelector('.video-canvas-wrap').offsetWidth;
    canvasHeight.value = canvasWidth.value * ratio;
    canvasRatio.value = canvasWidth.value / 1920;
  } else if (screenType === '竖屏' || props.digitalMan.resolution == '1080x1920') {
    const ratio = 1080 / 1920;
    canvasHeight.value = document.querySelector('.video-canvas-wrap').offsetHeight;
    canvasWidth.value = canvasHeight.value * ratio;
    canvasRatio.value = canvasHeight.value / 1080;
  } else if (props.digitalMan.resolution == '1280x720') {
    const ratio = 720 / 1280;
    canvasWidth.value = document.querySelector('.video-canvas-wrap').offsetWidth;
    canvasHeight.value = canvasWidth.value * ratio;
    canvasRatio.value = canvasWidth.value / 1280;
  } else if (props.digitalMan.resolution == '720x1280') {
    const ratio = 720 / 1280;
    canvasHeight.value = document.querySelector('.video-canvas-wrap').offsetHeight;
    canvasWidth.value = canvasHeight.value * ratio;
    canvasRatio.value = canvasHeight.value / 720;
  }
  emits('canvasSizeChange', canvasWidth.value, canvasHeight.value);
  initCanvas(screenType ? false : true);
};



function calculateScaleRatio(originalWidth, originalHeight, originalScale, targetWidth, targetHeight) {
  // 计算原图片的宽度
  const originalImageWidth = originalWidth / originalScale;

  // 基于目标画布的宽度计算新的缩放比
  const newScaleRatio = targetWidth / originalImageWidth;

  return newScaleRatio;
}




// 添加数字人
const digitalManRef = ref();
const centerPointer = ref();
const addDigitalman = () => {
  // 如果digitalManRef中已经有一个图像对象，则从canvas中移除它
  if (digitalManRef.value) canvas.value.remove(digitalManRef.value);


  // 获取canvas的宽度和高度
  const width = canvas.value.width;
  const height = canvas.value.height;


  // 从指定URL加载数字人的姿势图像并创建fabric.Image对象  
  fabric.Image.fromURL(props.digitalMan.poseImage, (image) => {

    image.crossOrigin = 'anonymous';

    // 分割并获取数字人图像的分辨率（假设为'宽度x高度'格式）
    const [rationW, rationH] = props.digitalMan.resolution?.split('x');
    // 设置最大高度为canvas高度（这里的乘以1可以视作是为了明确类型或适应某些框架的特性）
    const maxHeight = height * 1;
    const maxWidth = width * 1;
    // 记录原始图像的高度和宽度
    imageHeight.value = image.height;
    imageWidth.value = image.width;

    // 为图像设置ID和类型
    image.id = props.digitalMan.virtualManKey;
    image.type = 'digitalman';



    // 计算缩放比例并存储
    scaleRatio.value = calculateScaleRatio(Number(rationW), Number(rationH), Number(props.digitalMan.originZoomStr), maxWidth, maxHeight) * (props.anchorParam?.scale || 1)


    // 根据最大高度缩放图像
    image.scale(scaleRatio.value);



    let x = props.anchorParam.x ? (props.anchorParam.x || 1) / 100 * canvasWidth.value : null
    let y = props.anchorParam.y ? (props.anchorParam.y || 1) / 100 * canvasHeight.value : null


    // 设置图像的初始位置：顶部对齐canvas底部，水平居中
    image.top = y || height - image.height * scaleRatio.value;
    image.left = x || (width - image.width * scaleRatio.value) / 2;



    // 禁止图像旋转和翻转缩放
    image.lockRotation = true;
    image.lockScalingFlip = true;

    // 隐藏图像的部分控制手柄（ml, mb, mr, mt, mtr分别代表左中、下中、右中、上中和旋转手柄）
    image.setControlsVisibility({
      ml: false,
      mb: false,
      mr: false,
      mt: false,
      mtr: false,
    });


    // 将处理好的图像对象赋值给digitalManRef
    digitalManRef.value = image;

    // 将图像添加到canvas中
    canvas.value.add(digitalManRef.value);


    // 发送事件通知数字人已加载完成
    emits('loaded', false);
  }, { crossOrigin: 'anonymous' });
};

// 添加文字
const updateTextIdx = ref(0);
const updateTextReqId = ref(0);
const updateTextStartTime = ref(0);
const audioTextRef = ref();
const addAudioText = (str, cb) => {
  if (audioTextRef.value) canvas.value.remove(audioTextRef.value);
  const {
    fontSize,
    fill,
    stroke,
    strokeWidth,
    backgroundColor,
    shadowColor,
    shadowX,
    shadowY,
    shadowBlur,
    shadowDistance,
    left,
    top,
    rotate,
    scale,
    transparent,
  } = props.audioTextStyle;
  // console.log(111, props.audioTextStyle, props.audioText);
  let text = '';
  if (str) text = str;
  else text = props.audioText[0] ? props.audioText[0].sentence : '';
  audioTextRef.value = new fabric.Text(text, {
    bottom: 20,
    // left,
    fontSize,
    backgroundColor,
    fill,
    stroke,
    strokeWidth,
    rotate,
    scale: scale / 100,
    fontWeight: 800,
    shadow: `${shadowX} ${shadowY} ${shadowBlur} ${shadowColor}`,
  });


  audioTextRef.value.left = (canvas.value.width - audioTextRef.value.width) / 2;
  audioTextRef.value.top = canvas.value.height - 70;

  // 不允许水平移动
  audioTextRef.value.lockMovementX = true;

  // 不允许垂直移动
  audioTextRef.value.lockMovementY = true;

  // 禁止旋转
  audioTextRef.value.lockRotation = true;

  // 禁止水平缩放
  audioTextRef.value.lockScalingX = true;

  // 禁止垂直缩放
  audioTextRef.value.lockScalingY = true;

  // 不允许直接从画布框选
  audioTextRef.value.selection = true;


  canvas.value.add(audioTextRef.value);

  if (!cb) return;
  updateTextReqId.value = requestAnimationFrame(() => {
    if (updateTextIdx.value > props.audioText.length) {
      cancelAnimationFrame(updateTextReqId.value);
      // 停止播放，返回第一句话
      return;
    }
    let drawData = props.audioText[updateTextIdx.value];
    const lastIdx = drawData.words.length - 1;
    const endTimestamp = drawData.words[lastIdx].endTimestamp / 10000;
    if (endTimestamp < new Date().getTime() - updateTextStartTime.value + 30) {
      updateTextIdx.value++;
    }
    addAudioText(props.audioText[updateTextIdx.value].sentence, true);
  });
};

const updateText = () => {
  updateTextStartTime.value = new Date().getTime();
  addAudioText(props.audioText[updateTextIdx.value].sentence, true);
};

const initText = () => {
  updateTextIdx.value = 0;
  cancelAnimationFrame(updateTextReqId.value);
  updateTextReqId.value = 0;
  updateTextStartTime.value = 0;
  addAudioText();
};

// 添加浮动图片
const images = [];
const addImage = () => {
  const width = canvas.value.width;
  const height = canvas.value.height;
  const item = props.images[props.images.length - 1];
  if (!item) return;
  fabric.Image.fromURL(item.url, (img) => {
    const imgRef = ref();
    img.top = canvasHeight.value / 2;
    img.left = canvasWidth.value / 2;
    img.scaleX = canvasWidth.value / img.width / 3;
    img.scaleY = canvasWidth.value / img.width / 3;
    img.crossOrigin = 'anonymous'
    imgRef.value = img;
    images.push(imgRef.value);

    canvas.value.add(imgRef.value);
  }, { crossOrigin: 'anonymous' });
};



// 添加LOGO
const addLogo = (upDate) => {

  const width = canvas.value.width;
  const height = canvas.value.height;

  if (upDate) {
    const [rationW, rationH] = props.digitalMan?.resolution.split('x');

    props.logoParams.forEach((item) => {
      fabric.Image.fromURL(item.url, (logo) => {
        let canvasZoomRatio = rationW / item.scale
        let newLeft = item?.positionX ? item.positionX * (width / rationW) : 20
        let newTop = item?.positionY ? item.positionY * (height / rationH) : 20
        const logoRef = ref();
        logo.top = newTop
        logo.left = newLeft
        logo.scale(width / canvasZoomRatio);
        logo.lockRotation = true;
        logo.lockScalingFlip = true;
        logo.url = item.url;
        logo.type = 'logo';
        logo.id = item.id
        logo.crossOrigin = 'anonymous'
        logoRef.value = logo;


        let itemData = {
          id: logo.id,
          logoFileUrl: item.url,
          url: item.url,
          left: logo.left,
          top: logo.top,
          scaleX: (((logo.width * logo.scaleX) / canvasWidth.value) * rationW) / logo.width,
          scaleY: (((logo.height * logo.scaleY) / canvasHeight.value) * rationH) / logo.height,
          scale: item.scale,
          positionX: (logo.left / canvasWidth.value) * parseInt(rationW),
          positionY: (logo.top / canvasHeight.value) * parseInt(rationH),
        }


        emits('sourceChange', 11, itemData);
        logos.push(logoRef.value);
        canvas.value.add(logoRef.value);
      }
        , { crossOrigin: 'anonymous' }
      );
    });
  } else {

    const item = props.logoArr[props.logoArr.length - 1];
    if (!item) return;
    fabric.Image.fromURL(item.url, (logo) => {
      const logoRef = ref();
      logo.top = 20;
      logo.left = 20;
      logo.scale(scaleRatio.value);
      logo.id = item.id + '_' + new Date().getTime();
      logo.lockRotation = true;
      logo.url = item.url;
      logo.type = 'logo';
      logo.lockScalingFlip = true;
      logo.crossOrigin = 'anonymous'

      logo.setControlsVisibility({
        ml: false,
        mb: false,
        mr: false,
        mt: false,
        mtr: false,
      });
      logoRef.value = logo;
      const { angle, top, left, scaleX, scaleY, width, height, id } = logoRef.value;
      let transformInfo = { angle, top, left, scaleX, scaleY, width, height };
      transformInfo.oriScaleX = scaleX;
      const [rationW, rationH] = props.digitalMan?.resolution.split('x');
      transformInfo.scaleX = (((logo.width * scaleX) / canvasWidth.value) * rationW) / logo.width;
      transformInfo.scaleY = (((logo.height * scaleY) / canvasHeight.value) * rationH) / logo.height;
      const obj = { ...item, ...logo, ...transformInfo, url: item.url };

      emits('sourceChange', 11, obj);
      logos.push(logoRef.value);
      canvas.value.add(logoRef.value);
    }, { crossOrigin: 'anonymous' });
  }
};

// 事件总线打开弹窗
emitter.on('delLogo', (logoId) => {
  let target = logos.find((v) => v.id.includes(logoId));
  target && deleteEle(target);
});

const removeLogo = () => {
  logos.forEach((logo) => {
    canvas.value.remove(logo);
    emits('sourceChange', 11, null);
  });
};
// 清空画布
const clearCanvas = () => {
  // ctx.value.clearRect(0, 0, canvas.width, canvas.height);
};

// 设置文字前置
const setAudioTextFront = () => {
  bringToFront(audioTextRef.value);
};

// 最顶层
const bringToFront = (el) => {
  const target = el || contextELe.value;
  console.log(123, target);
  target.bringToFront();
};

// 最底层
const sendToBack = (el) => {
  const target = el || contextELe.value;
  target.sendToBack();
};

// 下移一层
const sendBackwards = (el) => {
  const target = el || contextELe.value;
  target.sendBackwards();
};

// 上移一层
const bringForward = (el) => {
  const target = el || contextELe.value;
  target.bringForward();
};

// 复制
const cloneObject = ref();
const copyEle = (el) => {
  const item = el || contextELe.value;
  item.clone((cloned) => {
    cloned.top = item.top + 20;
    cloned.left = item.left + 20;
    cloneObject.value = cloned;
  });
  contextmenus.value[1].disabled = false;
};

// 删除
const deleteEle = (el) => {
  const target = el || contextELe.value;
  console.log('删除', target);
  canvas.value.remove(target);
  if (target.type == 'logo') {
    const remove_idx = logos.findIndex((item) => item.id == target.id);
    logos.splice(remove_idx, 1);
    emits('sourceChange', 23, target.id);
  } else if (target.type == 'digitalman') {
    emits('sourceChange', 24);
  }
};

// 粘贴
const pasteEle = () => {
  canvas.value.add(cloneObject.value);
  bringToFront(cloneObject.value);
  canvas.value.discardActiveObject();
  cloneObject.value = null;
  contextmenus.value[1].disabled = true;
};
const frameCount = ref();

const videoELe = ref();
// 创建具有特定属性的视频元素的函数
const createVideo = (url) => {
  const video = document.createElement('video');
  video.src = url;
  video.muted = true; // 静音播放
  video.playbackRate = 16; // 播放速度
  video.currentTime = 0; // 视频当前时间
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('type', 'video/webm');
  video.setAttribute('preload', 'none');
  video.classList.add('video');
  video.style.display = 'none';
  window.document.body.appendChild(video);
  return video;
};

const framesStore = ref();
const cacheFrame = (url) => {
  return new Promise((resolve, reject) => {
    videoELe.value = createVideo(url);
    videoELe.value.play();
    console.log('start');
    // 监听视频元数据加载事件
    videoELe.value.addEventListener('loadedmetadata', () => {
      frameCount.value = Math.floor(videoELe.value.duration);
      // emits('durationChange', frameCount.value);
    });
  });
};
const updateTime = ref(0);
const requestId = ref(0);
const imgCanvas = ref();
const updateFrames = () => {
  requestId.value = 0;
  imgCanvas.value && canvas.value.remove(imgCanvas.value);
  function createFrame(video) {
    // if((new Date().getTime()) - updateTime.value > 10) {
    updateTime.value = new Date().getTime();
    imgCanvas.value && canvas.value.remove(imgCanvas.value);
    digitalManRef.value && canvas.value.remove(digitalManRef.value);

    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = imageWidth.value * scaleRatio.value;
    tempCanvas.height = imageHeight.value * scaleRatio.value;
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx?.drawImage(video, 0, 0, imageWidth.value * scaleRatio.value, imageHeight.value * scaleRatio.value);


    imgCanvas.value = new fabric.Image(tempCanvas, {
      scale: scaleRatio.value,
      width: imageHeight.value,
      height: imageWidth.value,
      top: canvasHeight.value - imageHeight.value * scaleRatio.value,
      left: (canvasWidth.value - imageWidth.value * scaleRatio.value) / 2,
    });
    canvas.value.add(imgCanvas.value);
    // }
    requestId.value = requestAnimationFrame(() => {
      createFrame(videoELe.value);
    });
  }
  videoELe.value.currentTime = 0;
  videoELe.value.play();
  videoELe.value.addEventListener('canplaythrough', (res) => {
    createFrame(videoELe.value);
  });

  videoELe.value.addEventListener('ended', (res) => {
    console.log('ended');
    videoELe.value.currentTime = 0;
    videoELe.value.play();
    // cancelAnimationFrame(requestId.value);
  });
};

const initDigitalman = () => {
  imgCanvas.value && canvas.value.remove(imgCanvas.value);
  imgCanvas.value = {};
  updateTime.value = 0;
  cancelAnimationFrame(requestId.value);
  videoELe.value.stop();
  requestId.value = 0;
  addDigitalman();
};

let loadingId = '';
const handleLoadstart = () => {
  if (!preloadUrl.value) return;
  if (loadingId) videoStore.removeSourceLoading(loadingId);
  loadingId = videoStore.addSourceLoading();
};

const handleLoadeddata = (e) => {
  if (loadingId) videoStore.removeSourceLoading(loadingId);
  loadingId = '';
  const { videoHeight: vh = 1, videoWidth: vw = 1 } = e.target
  videoWidth.value = vw
  videoHeight.value = vh
};

watch(
  () => props.digitalMan,
  (newVal) => {

    if (newVal.poseImage) {
      // addDigitalman();
      changeCanvasSize();
      cacheFrame(newVal.referenceVideoSegmentUrl);
    } else {
      digitalManRef.value && canvas.value.remove(digitalManRef.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

watch(
  () => props.background,
  (newVal) => {
    if (Object.keys(newVal)?.length) changeBackground();
  },
  {
    deep: true,
    immediate: true,
  }
);

watch(
  () => props.images,
  (newVal) => {
    if (newVal.length > 0) addImage();
  },
  {
    deep: true,
    immediate: true,
  }
);

watch(
  () => props.audioText,
  (newVal) => {
    if (newVal && newVal.length > 0) addAudioText();
  },
  {
    deep: true,
    // immediate: true,
  }
);

watch(
  () => props.playDemo,
  (newVal, oldVal) => {
    if (newVal) {
      console.log('ok1');

      props.audioText && props.audioText.length > 0 && updateText();
      // updateFrames();
      if (backgroundVideoPlayer.value) {
        backgroundVideoPlayer.value.play();
      }
    } else if (!newVal && oldVal) {
      console.log('ok2');

      // initDigitalman();
      props.audioText && props.audioText.length > 0 && initText();
      if (backgroundVideoPlayer.value) {
        backgroundVideoPlayer.value.pause();
        backgroundVideoPlayer.value.currentTime = 0;
      }
    }
  },
  {
    immediate: true,
  }
);

watch(
  () => props.clearFlag,
  (newVal) => {
    if (newVal) {
      canvas.value.clear();
    }
  }
);

watch(
  () => props.logoArr,
  (newVal) => {
    if (newVal.length > 0) addLogo();
    else removeLogo();
  },
  {
    deep: true,
    immediate: true,
  }
);

watch(
  () => [props.screen, props.digitalMan], // 监听两个属性组成的数组
  ([newScreen, newDigitalMan]) => {
    // 这里当props.screen或props.digitalMan任一变化时都会触发
    changeCanvasSize(newScreen);
  },
  { deep: true } // 如果props.screen或props.digitalMan是对象且需要深层变化监听，可以加上deep选项
);



watch(
  () => videoStore.clipVideoUrl || designerStore.bgVideoUrl,
  (newVal) => {
    if (newVal) {
      changeBackground();
      fetch(newVal)
        .then((response) => response.blob())
        .then((blob) => {
          // 生成Blob URL
          const blobUrl = URL.createObjectURL(blob);
          preloadUrl.value = blobUrl;
        });
    } else {
      preloadUrl.value = '';
    }
  },
  { immediate: true }
);

// watch(() => props.audioTextStyle, (newVal) => {
//   if(canvas.value && newVal && props.audioText) addAudioText();
// },{
//   deep: true,
//   immediate: true,
// })

onMounted(() => {
  const ratio = 1080 / 1920;
  canvasWidth.value = document.querySelector('.video-canvas-wrap').offsetWidth;
  canvasHeight.value = canvasWidth.value * ratio;
  emits('canvasSizeChange', canvasWidth.value, canvasHeight.value);
  initCanvas();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "digitalman-panel-content",
      style: _normalizeStyle({ width: _unref(canvasWidth) + 'px', height: _unref(canvasHeight) + 'px' })
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("canvas", {
        class: "video-canvas",
        id: "video-canvas"
      }, null, -1)),
      _withDirectives(_createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contextmenus.value, (menu) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["radius-middle-item", { disabled: menu.disabled }]),
            key: menu.value,
            onClick: ($event: any) => (handleContext(menu.value, menu.disabled))
          }, _toDisplayString(menu.label), 11, _hoisted_3))
        }), 128))
      ], 512), [
        [_vShow, contextShow.value]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("video", {
          ref_key: "backgroundVideoPlayer",
          ref: backgroundVideoPlayer,
          style: _normalizeStyle({ [fullWidth.value ? 'width' : 'height']: '100%' }),
          class: "background-video-player",
          src: preloadUrl.value,
          controls: false,
          preload: "auto",
          onLoadstart: handleLoadstart,
          onLoadeddata: handleLoadeddata
        }, null, 44, _hoisted_5), [
          [_vShow, preloadUrl.value]
        ])
      ])
    ], 4),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(copyImgFn) && _unref(copyImgFn)(...args)))
          }, "截图")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})